import React, { Component } from 'react'
import PropTypes from 'prop-types'

import _ from 'lodash'

import { withTranslation } from 'react-i18next'

import { eventCommunicator } from '../../../../communicators/eventCommunicator'

import { Page } from '../../../components/Page/Page'
import { SectionBlock } from '../../../components/SectionBlock/SectionBlock'
import { ErrorBoundary } from '../../../components/ErrorBoundary/ErrorBoundary'
import { PageInfo } from '../../../components/PageInfo/PageInfo'
import SingleEvent from './SingleEvent/SingleEvent'
import { EventList } from './EventList/EventList'

import './EventDetails.css'

class EventDetails extends Component {
    constructor(props) {
        super(props)

        this.state = {
            event: null,
            isLoading: true
        }
    }

    componentDidMount() {
        this.loadEvent()
    }

    componentDidUpdate(prevProps) {
        if (this.props.match.url !== prevProps.match.url) {
            this.loadEvent()
        }
    }

    async loadEvent() {
        try {
            // const eventId = Number.parseInt(this.props.match.params.id, 10)
            const { slug } = this.props.match.params

            const slugId = slug.split('-').slice(-1)[0]

            const eventId = Number.parseInt(slugId, 10) || slug

            const event = await eventCommunicator.fetchSingleEvent(eventId)
            this.setState({ event, isLoading: false })
        } catch (error) {
            console.error(error)
            this.setState({ isLoading: false })
        }
    }

    render() {
        const { event, isLoading } = this.state
        const { t } = this.props

        if (_.isEmpty(event)) {
            return <Page isLoading={isLoading} />
        }

        return (
            <Page
                isLoading={isLoading}
                title={`${t('headTitle')}/${event.title}`}
                description={event.eventDescription}
            >
                <section className="event-details">
                    <PageInfo
                        title={event.displayCategory}
                        breadcrumbs={t('eventDetails.breadcrumbs')}
                        bgImage="/images/dogadjaji1.jpg"
                        overlay
                    />
                    <SectionBlock withContainer>
                        <div className="event-details__wrap">
                            <ErrorBoundary>
                                <EventList categoryId={event.category.id} id={event.id} />
                            </ErrorBoundary>
                            <SingleEvent event={event} />
                        </div>
                    </SectionBlock>
                </section>
            </Page>
        )
    }
}

EventDetails.propTypes = {
    t: PropTypes.func
}

export { EventDetails }
export default withTranslation()(EventDetails)
